export default __webpack_public_path__ + "static/media/trivia.e4ca7bd7.png";